import React, {useState} from "react";
import "./ForInfluencersContent.scss";
import OctagonTab from "../OctagonTab";
import ForInfluencersVisuals from "./ForInfluencersVisuals";
import ForInfluencersBrandGuidelines from "./ForInfluencersBrandGuidelines";
import ForInfluencersAudio from "./ForInfluencersAudio";
import ForInfluencersVideo from "./ForInfluencersVideo";

export const ForInfluencersContent: React.FC = React.memo(() => {
    const MAIN_TAB_KEY = {
        VISUALS: 'visuals',
        VIDEO: 'video',
        AUDIO: 'audio',
        BRAND_GUIDELINES: 'brand-guidelines',
    };

    const [activeTabKey, setActiveTab] = useState(MAIN_TAB_KEY.VISUALS);

    const mainTabs = [
        {
            title: 'VISUALS',
            key: MAIN_TAB_KEY.VISUALS,
        },
        {
            title: 'VIDEO',
            key: MAIN_TAB_KEY.VIDEO,
        },
        {
            title: 'AUDIO',
            key: MAIN_TAB_KEY.AUDIO,
        },
        {
            title: 'BRAND GUIDELINES',
            key: MAIN_TAB_KEY.BRAND_GUIDELINES,
            large: true,
        }
    ];

    return (
        <div className="for-influencers-content">
            <div className="for-influencers-content-inner">
                <div className="content-block">
                    <div className="main-tabs-container">
                        <div className="main-tabs">
                            {mainTabs.map((tab) => (
                                <OctagonTab
                                    key={tab.key}
                                    text={tab.title}
                                    onClick={() => setActiveTab(tab.key)}
                                    isActive={activeTabKey === tab.key}
                                    large={tab.large}
                                />
                            ))}
                        </div>
                    </div>
                    {activeTabKey === MAIN_TAB_KEY.VISUALS && (
                        <ForInfluencersVisuals/>
                    )}
                    {activeTabKey === MAIN_TAB_KEY.VIDEO && (
                            <ForInfluencersVideo/>
                    )}
                    {activeTabKey === MAIN_TAB_KEY.AUDIO && (
                        <ForInfluencersAudio/>
                    )}
                    {activeTabKey === MAIN_TAB_KEY.BRAND_GUIDELINES && (
                        <ForInfluencersBrandGuidelines/>
                    )}
                </div>
            </div>
        </div>
    )
});